import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'zef-app',
  template: `
    <router-outlet></router-outlet>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DocsApp {}
